import { motion } from 'motion/react';
import { XCircle } from 'lucide-react';
import { ADMIN_COLORS } from '@/features/admin/utils/adminAnimations';

interface ErrorStateProps {
  message: string;
}

export function ErrorState({ message }: ErrorStateProps) {
  return (
    <motion.div
      key="error"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="rounded-xl p-8 text-center glass-surface"
      style={{
        backgroundColor: ADMIN_COLORS.surface,
        border: `1px solid ${ADMIN_COLORS.border}`,
        boxShadow: ADMIN_COLORS.shadow,
      }}
    >
      <XCircle className="w-14 h-14 mx-auto mb-4" />
      <p className="text-xl font-bold">{message}</p>
    </motion.div>
  );
}
